var React = require('react');

function GatsbyOriginal (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#64328B","d":"M64 0C28.7 0 0 28.7 0 64s28.7 64 64 64 64-28.7 64-64S99.3 0 64 0zM13.2 64L64 114.8c-28.1 0-50.8-22.7-50.8-50.8zm62.2 49.5l-60.9-61C19.7 30 39.9 13.2 64 13.2c16.6 0 31.3 7.9 40.5 20.2L97 40.6c-7.3-10.4-19.3-17.1-33-17.1-17.6 0-32.5 11.2-38.1 26.8C33.1 57 75.4 98.8 78.1 102c12.7-4.7 22.3-15.5 25.4-28.9H81.9v-9.4l33 .2c-.1 24.3-16.9 44.5-39.5 49.6z"}));
}

GatsbyOriginal.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = GatsbyOriginal;

GatsbyOriginal.default = GatsbyOriginal;
